module.exports = __webpack_public_path__ + "static/partners-compressed-4436b7ef9f830139bbeabe3c269ac55a.mp4";